<template>
  <div class="login">
    <div class="login-con">
      <Card icon="log-in" title="欢迎登录" :bordered="false">
        <div class="form-con">
          <Form ref="loginForm" :model="form" :rules="form_rule" @keydown.enter.native="handleSubmit">
            <FormItem prop="mobile">
              <Input v-model="form.mobile" placeholder="请输入用户名">
                <span slot="prepend">
                  <Icon :size="16" type="ios-person"></Icon>
                </span>
              </Input>
            </FormItem>
            <FormItem prop="password">
              <Input type="password" v-model="form.password" placeholder="请输入密码">
                <span slot="prepend">
                  <Icon :size="14" type="md-lock"></Icon>
                </span>
              </Input>
            </FormItem>
            <FormItem>
              <Button @click="handleSubmit" type="primary" long :loading="loginLoading">登录</Button>
            </FormItem>
          </Form>
        </div>
      </Card>
    </div>
  </div>
</template>

<script>
  import { doLogin } from '@/api/login'
  import { setToken,dealAuthRoute } from "@/lib/util";
  import VueRouter from 'vue-router'
  import { routes as staticRoutes } from '@/router/routes';

  export default {
    name: "login",
    data(){
      return {
        form:{
          mobile:'',
          password:'',
        },
        loginLoading: false, // 新增loading状态
        form_rule:{
          mobile:[
            {required: true,type: 'string',message: '请输入用户名!'},
          ],
          password:[
            {required: true,type: 'string',message: '请输入密码'},
            {
              validator:(rule,value,callback) => {
                return value.length < 4 ? callback(new Error('密码至少为4位')) : callback()
              }
            }
          ],
        }
      }
    },
    methods:{
      async handleSubmit(){
        this.loginLoading = true; // 开始loading
        let valid = await this.$refs.loginForm.validate((validate) => {
          return validate
        })
        if(!valid){
          this.loginLoading = false; // 校验失败关闭loading
          return  this.$commonFun.errorTip('账号或密码不正确')
        }
        let res = await doLogin(this.form)
        this.$commonFun.dealApiResult(res,() => {
          sessionStorage.setItem('user_name',res.data.user_info.name)
          let groupID = res.data.user_info.group_id + '';
          sessionStorage.setItem('groupID',groupID);
          sessionStorage.setItem('userInfo',JSON.stringify(res.data.user_info));
          // 兼容后端可能返回的字段名：multiAccounts 或 multi_accounts，及 user_info 内的同名字段
          const multiAccounts = res.data.multiAccounts
            || res.data.multi_accounts
            || (res.data.user_info && (res.data.user_info.multiAccounts || res.data.user_info.multi_accounts))
            || []
          sessionStorage.setItem('multiAccounts', JSON.stringify(multiAccounts))
          // 重置路由表，移除之前会话添加的动态路由（vue-router 3 不支持删除路由，通过重置 matcher 实现），
          // 避免旧会话的 404 通配符路由保留在路由表前面，拦截新账号登录后的真实路由
          this.$router.matcher = new VueRouter({ routes: staticRoutes }).matcher
          dealAuthRoute(undefined, { routerInstance: this.$router, storeInstance: this.$store })
          setToken(res.data.token)
          // 根据用户组ID跳转到不同的首页
          const groupIDNum = parseInt(groupID);
          if (groupIDNum === 3) {
            // 合伙人跳转到/dashboard
            this.$commonFun.jumpTo('/dashboard')
          } else {
            // 其他角色跳转到/home
            this.$commonFun.jumpTo('/home')
          }
        })
        this.loginLoading = false; // 登录完成关闭loading
      }
    }
  }
</script>

<style scoped lang="less">
  .login{
    width: 100%;
    height: 100%;
    background-image: url('../../../assets/images/login-bg.jpg');
    background-size: cover;
    background-position: center;
    position: relative;
    &-con{
       position: absolute;
       right: 160px;
       top: 50%;
       transform: translateY(-60%);
       width: 300px;
      &-header{
         font-size: 16px;
         font-weight: 300;
         text-align: center;
         padding: 30px 0;
       }
      .form-con{
        padding: 10px 0 0;
      }
      .login-tip{
        font-size: 10px;
        text-align: center;
        color: #c3c3c3;
      }
    }
  }
</style>
